import { X } from 'lucide-react';
import { formatCurrency } from '../../data/mockData';
import { formatPrice, formatStock, isSoldByWeight } from '../../utils/soldBy';
import styles from './LotPickerModal.module.css';

export default function LotPickerModal({ item, lots, onSelect, onClose }) {
  return (
    <div className={styles.overlay} role="dialog" aria-modal="true" aria-labelledby="lot-picker-title">
      <div className={styles.modal}>
        <button type="button" className={styles.closeBtn} onClick={onClose} aria-label="Close">
          <X size={16} />
        </button>
        <h2 id="lot-picker-title" className={styles.title}>
          {isSoldByWeight(item) ? 'Pick lot rate' : 'Pick pack price'}
        </h2>
        <p className={styles.subtitle}>
          {isSoldByWeight(item)
            ? `${item?.name} has lots at different rates. Choose the lot, then enter the weight.`
            : `${item?.name} has packs at different sell prices. Choose the lot that matches the physical pack.`}
        </p>
        <div className={styles.list}>
          {lots.map((lot) => (
            <button
              key={lot.lotId}
              type="button"
              className={styles.lotBtn}
              disabled={lot.qty <= 0}
              onClick={() => onSelect(lot)}
            >
              <span className={styles.lotSell}>
                {formatPrice({ ...item, price: lot.sellingPrice }, formatCurrency)}
              </span>
              <span className={styles.lotMeta}>
                {lot.mrp != null ? `MRP ${formatCurrency(lot.mrp)}` : 'No MRP'}
                {' · '}
                {formatStock(lot.qty, item)} available
              </span>
              {lot.receivedAt && (
                <span className={styles.lotDate}>
                  Received {new Date(lot.receivedAt).toLocaleDateString('en-IN', { day: '2-digit', month: 'short' })}
                </span>
              )}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
